module.exports = __webpack_public_path__ + "media/warranty/panther-75b03bbc.png";